import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/Button';
import { Check, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PlanEssential() {
  const features = ['Single WooCommerce Store Integration', 'Real-time KRA eTims Synchronization', 'Automated Daily Reporting', 'Basic Analytics Dashboard', 'Email Support (24h Response)', 'Automatic Compliance Updates', 'Secure Data Encryption', '30-Day History Retention'];
  return <div className="min-h-screen bg-sovereign-navy text-white pt-20 pb-32" data-id="element-240">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-241">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-242">
          <span className="text-gray-400 uppercase tracking-widest text-sm font-medium mb-4 block" data-id="element-243">
            The Foundation
          </span>
          <h1 className="text-5xl md:text-6xl font-serif text-white mb-6" data-id="element-244">
            Essential
          </h1>
          <p className="text-xl text-gray-400 font-light max-w-2xl mx-auto" data-id="element-245">
            Perfect for growing businesses that demand compliance without
            complexity.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-sovereign-navy-light p-12 shadow-xl border border-sovereign-gold/20 relative overflow-hidden" data-id="element-246">
          <div className="flex flex-col md:flex-row justify-between items-baseline mb-12 border-b border-white/10 pb-8" data-id="element-247">
            <div data-id="element-248">
              <span className="text-5xl font-serif text-white" data-id="element-249">KES 4,999</span>
              <span className="text-gray-400 ml-2 font-light" data-id="element-250">/ year</span>
            </div>
            <Link to="/contact" data-id="element-251">
              <Button className="mt-6 md:mt-0" data-id="element-252">
                Get Started <ArrowRight className="ml-2 h-4 w-4" data-id="element-253" />
              </Button>
            </Link>
          </div>

          <div className="grid md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-254">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.4 + index * 0.1
          }} className="flex items-start gap-3" data-id="element-255">
                <Check className="w-5 h-5 text-sovereign-gold mt-0.5 flex-shrink-0" data-id="element-256" />
                <span className="text-gray-300 font-light" data-id="element-257">{feature}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </div>;
}